import React from 'react';

const RateTipIcon = (props) => {
  const { color } = props;
  return (
    <svg
      className="ratetip"
      width="38px"
      height="20px"
      viewBox="0 0 38 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs />
      <g id="Reviews" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Review" transform="translate(-797.000000, -365.000000)">
          <g id="Group-3" transform="translate(605.000000, 359.000000)">
            <g id="Group-2" transform="translate(192.000000, 6.000000)">
              <path
                d="M5,0 L36,0 C37.1045695,-2.02906125e-16 38,0.8954305 38,2 L38,18 C38,19.1045695 37.1045695,20 36,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,13 L0,10 L3,7 L3,2 C3,0.8954305 3.8954305,2.02906125e-16 5,0 Z"
                id="Rectangle-3"
                fill={color}
              />
              <text
                id="Rate"
                fontFamily="Open Sans"
                fontSize="12"
                fontWeight="500"
                linespacing="18"
                fill="#FFFFFF"
              >
                <tspan x="7" y="13">
                  Rate
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

RateTipIcon.defaultProps = {
  color: '#A7AEB3',
};

export default RateTipIcon;
